import React, { FC, ReactElement } from 'react'

// Lucide-react `LayoutDashboard` icon, inlined so it matches the akixi-frontend toggle pixel-for-pixel.
// https://lucide.dev/icons/layout-dashboard (ISC licensed).

type Props = {
    size?: number
}

const LayoutDashboardIcon: FC<Props> = ({ size = 16 }: Props): ReactElement => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden='true'
    >
        <rect width='7' height='9' x='3' y='3' rx='1' />
        <rect width='7' height='5' x='14' y='3' rx='1' />
        <rect width='7' height='9' x='14' y='12' rx='1' />
        <rect width='7' height='5' x='3' y='16' rx='1' />
    </svg>
)

export default LayoutDashboardIcon
